import { useSelector } from "react-redux";
import styles from "./index.module.scss";
import { formatPrice } from "../../../../../utils";

export default function Price({ product }) {
  const catalog = product.CATALOG;
  const isAvailable = catalog.AVAILABLE;
  const price = catalog.MIN_PRICE;
  const noDiscountPrice = catalog.PRICE;

  const { host } = useSelector((state) => state.params);
  const subDomain = host.split(".")[0];
  return (
    <div>
      <div
        className={styles.Price}
        itemProp="offers"
        itemScope
        itemType="http://schema.org/Offer"
      >
        <span itemProp="priceCurrency" style={{ display: "none" }}>
          RUB
        </span>
        <span itemProp="price" style={{ display: "none" }}>
          {price}
        </span>
        <link itemProp="availability" href="http://schema.org/InStock" />
        {isAvailable && noDiscountPrice > price && (
          <div className={styles.BeforeValue}>{noDiscountPrice} руб</div>
        )}
        {!isAvailable && (
          <div className={styles.LastValue}>Последняя цена:</div>
        )}
        <div className={styles.Value}>
          <span>
            <span>{formatPrice(price)}</span> руб
          </span>
        </div>
      </div>
      {["msk", "spb"].includes(subDomain) && (
        <div className={styles.PriceInfo}>*стоимость товара без установки</div>
      )}
    </div>
  );
}
